var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WaitlistCard',{attrs:{"feature":"automated reactivation campaigns","onWaitlist":!!_vm.reactivationWaitlist,"signupAction":_vm.REACTIVATION_WAITLIST_SIGNUP}})}
var staticRenderFns = []

export { render, staticRenderFns }